import { ICountry } from 'src/types/venue.types';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const getCountries = async (): Promise<ICountry[]> => {
  const response = await fetch(`${API_URL}/venues/countries`, {});
  const json = await response.json();

  const transformedData =
    json.data?.map((country) => ({
      name: country.name,
      alpha3code: country.alpha_3_code,
    })) || [];

  return transformedData;
};
